import type { RunsIn } from '../env';
import { env } from '../env';

export const getByRunsIn = <T>(map: Record<RunsIn, T>) =>
	map[env.CLIENT_RUNS_IN];
